/**
 * The cleanObjectsEmptyProperties function takes an object as a parameter
 * and returns the same object with all empty properties removed.
 * @param objectToClean Pass in the object that you want to clean
 *
 * @return Object without empty or null properties.
 */
const cleanObjectsEmptyProperties = (objectToClean) =>
  Object.fromEntries(Object.entries(objectToClean).filter(([, value]) => value !== null && value !== undefined));

module.exports = cleanObjectsEmptyProperties;
